// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2X0t3","empty":"ModalGraph_empty__3RfSQ"};